export default "__VITE_ASSET__DspcdeJg__"